import { Box, CircularProgress } from '@cambridgeassessment/cambridge-ui';
import React, { memo } from 'react';
import { hot } from 'react-hot-loader/root';

export type Props = {
  height?: number | string;
};

const Loader: React.FC<Props> = ({ height }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="100%"
      height={height || '100%'}
    >
      <CircularProgress data-testid="circular-progress" />
    </Box>
  );
};

export default hot(memo(Loader));
